import type { CalculationState, CompletedCalculationTactic } from '../../index';
import { parseGridElementType } from './parseGridElementType';

export const functionalGridElements = (
  state: CalculationState
): CalculationState['functionalGridElements'] => {
  if (state.isCalculationTacticResultUnavailable)
    return { type: 'NOT_AVAILABLE' };

  const calculationTactic = state.calculationTactic
    .value as unknown as CompletedCalculationTactic;

  const allFunctionalGridElements = Object.entries(
    calculationTactic.calculationSetResult.grid.functional
  ).flatMap(([gridElementType, functionalGridElements]) =>
    functionalGridElements.map(functionalGridElement => ({
      ...functionalGridElement,
      objectType: parseGridElementType(gridElementType)
    }))
  );

  if (allFunctionalGridElements.length === 0) return { type: 'NOT_AVAILABLE' };

  return {
    type: 'FUNCTIONAL_GRID_ELEMENTS',
    gridElements: allFunctionalGridElements as any
  };
};
